<template>
	<div class="detail main-content-padding">
		<div class="content">
			<div class="pl-24 pr-24 mt-4">
				<el-tabs v-model="activeTab" @tab-click="handleClick">
					<el-form class="mt-12" v-show="activeTab === '0' && hasDeptDataScope">
						<el-form-item label="跟进人" label-width="80px">
							<el-select
								v-model="followValue"
								placeholder="请选择"
								filterable
								clearable
								@change="refreshCooperation"
								style="width: 160px"
								size="mini"
							>
								<el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<el-tab-pane label="合作数据" name="0"> </el-tab-pane>
					<!-- <el-tab-pane label="带货商品" name="1">
						<goods-hand ref="goodsHand" :authorityId="id" :platformId="platformId" />
					</el-tab-pane> -->
					<el-tab-pane label="关联达人" name="2"> </el-tab-pane>
					<el-tab-pane label="联系人" name="3"> </el-tab-pane>
				</el-tabs>
				<cooperation-tab v-show="+activeTab === 0" ref="cooperationTab" :id="id" />
				<talent-tab v-show="+activeTab === 2" :platformId="platformId" ref="talentTab" :id="id" :institution-name="institutionName" />
				<contact-tab v-show="+activeTab === 3" ref="contactTab" :id="id" />
			</div>
		</div>
		<div class="right">
			<template v-if="$isDy(platformId)">
				<div class="info">
					<div v-if="$auth.hasPermi('system:cooperativeColonel:add-edit')" class="iconfont icon-a-edit-obianji" @click="showPartnerDialog"></div>
					<div class="align-center">
						<YxAvatar :size="68" src="" :placeholder="institutionInfo.institution_name ? institutionInfo.institution_name[0] : ''" >
                        </YxAvatar>
						<div class="title">
							<span class="ellipsis">{{ institutionInfo.institution_name }}</span>
							<platform-icon :platformId="institutionInfo.platform_id"></platform-icon>
						</div>
						<div class="tag" :class="institutionInfo.authorize ? 'success' : 'error'">{{ institutionInfo.authorize ? '已' : '暂未' }}授权</div>
						<div class="ellipsis mt-24 yx-color-text-regular fz-13">
							<span>主推类目：</span>
							<el-tooltip
								v-if="recommend_type(institutionInfo.recommend_type_name)"
								:content="recommend_type(institutionInfo.recommend_type_name)"
								placement="top"
							>
								<span>{{ recommend_type(institutionInfo.recommend_type_name) }}</span>
							</el-tooltip>
							<span v-else>-</span>
						</div>
					</div>
					<div class="mt-12 fz-12 font-bold">数据表现</div>
					<div class="flex mt-12 flex-just-between">
						<div class="item-num">
							<div class="num">{{ institutionInfo.order_anchor_num }}</div>
							<div class="text">出单达人数</div>
						</div>
						<div class="item-num">
							<div class="num">{{ institutionInfo.order_product_num }}</div>
							<div class="text">出单商品数</div>
						</div>
						<div class="item-num">
							<div class="num">¥{{ sale_amount(institutionInfo.sale_amount) }}</div>
							<div class="text">总销售额</div>
						</div>
					</div>
					<div class="mt-16 fz-12 font-bold">跟进信息</div>
					<div class="fz-13 mt-12 yx-color-text-regular">
						<div>跟进人: {{ userNames }}</div>
						<div class="mt-8">创建时间: {{ institutionInfo.add_time }}</div>
						<div class="mt-8 flex">
							<span style="white-space: nowrap">备注：</span>
							<el-tooltip v-if="institutionInfo.remark" :content="institutionInfo.remark" placement="top">
								<div class="ellipsis">{{ institutionInfo.remark }}</div>
							</el-tooltip>
							<span v-else>-</span>
						</div>
					</div>
					<div class="align-center mt-8">
						<el-button type="text" v-if="$auth.hasPermi('system:myActivities:query')" @click="goToActivity"
							>查看招商活动<i class="el-icon-arrow-right el-icon--right"></i
						></el-button>
					</div>
				</div>
			</template>
			<template v-if="$isKs(platformId)">
				<div class="info">
					<div
						@click="showKsPartnerDialog"
						v-if="$auth.hasPermi('system:cooperativeColonel:add-edit')"
						class="cursor-pointer font-h4-regular hover yx-color-text-regular flex-row-align-center flex-just-end"
					>
						<i class="iconfont icon-a-edit-obianji"></i>
						<span class="ml-4">编辑</span>
					</div>
					<div class="text-align-center">
						<YxAvatar :size="68" src="" :placeholder="institutionInfo.institutionName ? institutionInfo.institutionName[0] : ''" ></YxAvatar>
						<div class="title">
							<el-tooltip class="item" effect="dark" :content="institutionInfo.institutionName" placement="top">
								<span class="line-ellipsis-1 yx-pingfang-Medium mr-4">{{ institutionInfo.institutionName }}</span>
							</el-tooltip>
							<platform-icon :platformId="institutionInfo.platformId"></platform-icon>
						</div>
						<div>
							<el-button type="text" @click="contactTeam(institutionInfo)" v-if="institutionInfo.officialContactPhone">
								<i class="el-icon-phone"></i>
								联系团长
							</el-button>
						</div>
						<!-- <div class="tag" :class="institutionInfo.authorize ? 'success' : 'error'">{{ institutionInfo.authorize ? '已' : '暂未' }}授权</div> -->
						<div class="num line-ellipsis-1 mt-8 yx-color-text-regular font-h5-regular">
							<span>招商活动数：</span>
							<span>{{ extraData.activityCount || 0 }}</span>
						</div>
						<div class="num line-ellipsis-1 mt-8 yx-color-text-regular font-h5-regular">
							<span>推广成交商家数：</span>
							<span>{{ extraData.tradeSellerCount || 0 }}</span>
						</div>
						<div class="num line-ellipsis-1 mt-8 yx-color-text-regular font-h5-regular">
							<span>推广成交商品数：</span>
							<span>{{ extraData.itemOrderCount || 0 }}</span>
						</div>
						<div class="num line-ellipsis-1 mt-8 yx-color-text-regular font-h5-regular">
							<span>单品平均成交量：</span>
							<span>{{ extraData.tradeItemCount || 0 }}</span>
						</div>
						<div class="num line-ellipsis-1 mt-8 yx-color-text-regular font-h5-regular">
							<span>客单价：</span>
							<span>{{ extraData.customerPrice || 0 }}</span>
						</div>
					</div>
					<div class="mt-16 font-h6-medium">跟进信息</div>
					<div class="font-h5-regular mt-12 yx-color-text-regular">
						<div>跟进人: {{ userNames }}</div>
						<div class="mt-8">创建时间: {{ institutionInfo.addTime }}</div>
						<div class="mt-8 flex-row" v-if="institutionInfo.remark">
							<span style="white-space: nowrap">备注：</span>
							<el-tooltip :content="institutionInfo.remark" placement="top">
								<div class="line-ellipsis-1">{{ institutionInfo.remark }}</div>
							</el-tooltip>
						</div>
					</div>
                  
					<div class="text-align-center mt-8">
						<el-button style="width: 210px" size="medium" @click="handleAddress"> 团长地址 </el-button>
					</div>
				</div>
			</template>
		</div>

		<!-- 编辑dy团长 -->
		<partner-dialog ref="partnerDialog" @getList="getInstitutionInfo" />

		<!-- 编辑快手团长 -->
		<Kpartner-dialog ref="KpartnerDialog" :platformId="platformId" @refresh="getInstitutionInfo" />

		<!-- 新增团长地址 -->
		<AddressManageDrawer ref="addressManageDrawer" />
	</div>
</template>

<script>
// import avatar from '../components/avatar';
import cooperationTab from './components/cooperationTab';
import talentTab from './components/talentTab';
import contactTab from './components/contactTab';
import partnerDialog from '../components/partnerDialog';
import KpartnerDialog from '../components/KpartnerDialog';
import goodsHand from './components/goodsHand';
import { getInstitutionInfo, institutionDetail, followUserList } from '@/api/secondColonelManage';
import AddressManageDrawer from '@/components/business/addressManageDrawer';
import { mapGetters } from 'vuex';
export default {
	name: 'detail',
	components: {
		cooperationTab,
		talentTab,
		contactTab,
		partnerDialog,
		KpartnerDialog,
		AddressManageDrawer,
		goodsHand,
	},
	created() {
		this.id = this.$route.query.id;
		this.getInstitutionInfo();
		this.followUserList();
	},
	data() {
		return {
			activeTab: '0',
			id: 0,
			institutionInfo: {},
			extraData: {},
			userNames: '',
			userList: [],
			followValue: '',
			selectVal: '',
		};
	},
	computed: {
		...mapGetters(['hasDeptDataScope']),
		recommend_type() {
			return (arr = []) => arr.join('/');
		},
		sale_amount() {
			return sale_amount => {
				const baseNum = 10000;
				if (sale_amount >= baseNum) return +(sale_amount / baseNum).toFixed(2) + '万';
				return sale_amount;
			};
		},
		platformId() {
			return this.$route.query.platformId || dataMap.PLATFORM_DY.value;
		},
		institutionName({ platformId, institutionInfo }) {
			const name = {
				[dataMap.PLATFORM_DY.value]: 'institution_name',
				[dataMap.PLATFORM_KS.value]: 'institutionName',
			};
			return institutionInfo[name[platformId]];
		},
	},
	methods: {
		handleClick() {
			const tabName = ['cooperationTab', 'goodsHand', 'talentTab', 'contactTab'][this.activeTab];
			this.$refs[tabName].getInfo(this.selectVal);
		},
		async getInstitutionInfo() {
			const { id, platformId } = this;
			const api = {
				[dataMap.PLATFORM_DY.value]: getInstitutionInfo,
				[dataMap.PLATFORM_KS.value]: institutionDetail,
			};
			const params = {
				[dataMap.PLATFORM_DY.value]: { id },
				[dataMap.PLATFORM_KS.value]: { teamInstitutionId: id },
			};
			const { code, data = {} } = await api[platformId](params[platformId]);
			if (code !== 0) return;
			this.institutionInfo = data;
			this.extraData = data.extraData || {};
			this.userNames = data?.userNames?.join(',');
			this.$nextTick(_ => this.$refs.cooperationTab.getInfo());
		},
		showPartnerDialog() {
			this.$refs.partnerDialog.show(this.id);
		},
		showKsPartnerDialog() {
			this.$refs.KpartnerDialog.show(this.id);
		},
		goToActivity() {
			const handLink = this.$router.resolve({
				path: '/secondColonelManage/colonelActivitySquare/list',
				query: { q: this.institutionInfo.institution_name },
			});
			window.open(handLink.href, '_blank');
		},
		handleAddress() {
			this.$refs.addressManageDrawer.show(this.institutionInfo.id);
		},
		async followUserList() {
			//delete0所有， 1未删除，2删除
			const { id: teamInstitutionId, platformId } = this;
			const data = await followUserList({ platformId: platformId, teamInstitutionId, delete: 1 });
			this.userList = data;
		},
		refreshCooperation(e) {
			this.selectVal = e;
			this.$refs['cooperationTab'].getInfo(e);
		},
	},
};
</script>

<style lang="less" scoped>
.detail {
	background-color: #f5f5f5;
	display: flex;
	padding-bottom: 24px;
	min-height: 100%;

	.content {
		flex: 1;
		background-color: #fff;
		border-radius: 4px;
	}

	.right {
		width: 240px;
		background-color: #f5f5f5;
		margin-left: 16px;
		color: #333;

		.info {
			background-color: #fff;
			padding: 16px;
			border-radius: 4px;

			.icon-a-edit-obianji {
				text-align: right;
				color: #666;
				cursor: pointer;

				&:hover {
					color: @color-primary;
				}
			}

			::v-deep .default {
				color: #fda9a1;
				font-size: 35px;
				font-weight: 400;
			}

			.title {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 18px;
				font-size: 14px;
				font-weight: bold;

				.ellipsis {
					max-width: 182px;
					margin-right: 4px;
				}
			}

			.tag {
				margin-top: 8px;
				display: inline-block;
				border-radius: 2px;
				padding: 0 6px;
				font-size: 12px;
				height: 18px;
				line-height: 19px;

				&.error {
					color: #fa8f14;
					background-color: #fef3e7;
				}

				&.success {
					color: #0fb820;
					background-color: #f0fff1;
				}
			}

			.item-num {
				font-size: 12px;
				line-height: 17px;

				.num {
					color: #000;
					font-weight: bold;
				}

				.text {
					color: #666;
					margin-top: 4px;
				}

				.price-text {
					display: inline-block;
					transform: scale(0.66666);
				}
			}
		}
		.tag {
			margin-top: 8px;
			display: inline-block;
			border-radius: 2px;
			padding: 0 6px;
			font-size: 12px;
			height: 18px;
			line-height: 19px;
			&.error {
				color: #fa8f14;
				background-color: #fef3e7;
			}
			&.success {
				color: #0fb820;
				background-color: #f0fff1;
			}
		}
		.num {
			text-align: left;
		}
	}
}
</style>
